import { useQuery } from "@tanstack/react-query";
import { getProject, PROJECT_IN_FLIGHT, type ProjectRead } from "@/api/projects";

/** Polls a project every 3s while its agent run is in-flight (mirrors use-run). */
export function useProject(projectId: string) {
  return useQuery({
    queryKey: ["project", projectId],
    queryFn: () => getProject(projectId),
    enabled: !!projectId,
    refetchInterval: (q) => {
      const data = q.state.data as ProjectRead | undefined;
      if (!data) return false;
      // Poll while the agent is running, AND while a freshly-uploaded project is
      // still "draft" with files (its task file's text extraction runs async — we
      // need to catch the draft→ready flip so the Generate CTA appears).
      if (PROJECT_IN_FLIGHT.includes(data.status)) return 3000;
      if (data.status === "draft" && data.files.length > 0) return 3000;
      return false;
    },
  });
}
